import React, { useState, useRef } from "react";
import "../../css/Common.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

function CommunicationContext({ value, onChange }) {
  const [tooltipStyle, setTooltipStyle] = useState({ display: "none" });
  const iconRef = useRef(null);
  const showTooltip = () => {
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setTooltipStyle({
        display: "block",
        top: `${rect.top - 20}px`,
        left: `${rect.right + 20}px`,
      });
    }
  };

  const hideTooltip = () => {
    setTooltipStyle({ display: "none" });
  };

  const handleCheckboxChange = (context) => {
    console.log("=== COMMUNICATION CONTEXT CHANGE ===");
    console.log("Context being toggled:", context);
    console.log("Current value:", value);

    const newValue = value.includes(context)
      ? value.filter((c) => c !== context)
      : [...value, context];

    console.log("New value:", newValue);
    console.log("======================================");

    onChange((prev) =>
      prev.includes(context)
        ? prev.filter((c) => c !== context)
        : [...prev, context]
    );
  };

  const contexts = [
    { id: "general", label: "General" },
    { id: "events", label: "Events" },
    { id: "regional", label: "Regional" },
    { id: "financial", label: "Financial" },
    { id: "emergencies", label: "Emergencies" },
    { id: "personalized", label: "Personalized" },
  ];

  return (
    <div className="common-form-group">
      <div className="common-form-field">
        <div className="common-label-container">
          <label className="common-label-with-icon">
            Communication Context
          </label>
          <FontAwesomeIcon
            ref={iconRef}
            icon={faCircleInfo}
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}
            className="common-info-icon"
          />
        </div>
        <div className="control-tooltip" style={tooltipStyle}>
          General circumstances of the communication to make it more
          personalized
        </div>
      </div>

      {/* <div className="common-form-group">
        <div className="common-checkbox-container">
          <div className="common-columns">
            <div className="common-column">
              <label className="common-checkbox-label">
                <input
                  type="checkbox"
                  value="general"
                  checked={value.includes("general")}
                  onChange={() => handleCheckboxChange("general")}
                />
                <span>General</span>
              </label>
              <label className="common-checkbox-label">
                <input
                  type="checkbox"
                  value="personalized"
                  checked={value.includes("personalized")}
                  onChange={() => handleCheckboxChange("personalized")}
                />
                <span>Personalized</span>
              </label>
              <label className="common-checkbox-label">
                <input
                  type="checkbox"
                  value="regional"
                  checked={value.includes("regional")}
                  onChange={() => handleCheckboxChange("regional")}
                />
                <span>Regional</span>
              </label>
            </div>
            <div className="common-column">
              <label className="common-checkbox-label">
                <input
                  type="checkbox"
                  value="event-based"
                  checked={value.includes("event-based")}
                  onChange={() => handleCheckboxChange("event-based")}
                />
                <span>Events</span>
              </label>
              <label className="common-checkbox-label">
                <input
                  type="checkbox"
                  value="emergencies"
                  checked={value.includes("emergencies")}
                  onChange={() => handleCheckboxChange("emergencies")}
                />
                <span>Emergencies</span>
              </label>
              <label className="common-checkbox-label">
                <input
                  type="checkbox"
                  value="financial"
                  checked={value.includes("financial")}
                  onChange={() => handleCheckboxChange("financial")}
                />
                <span>Financial</span>
              </label>
            </div>
          </div>
        </div>
      </div> */}

      <div className="common-form-group">
        <div className="common-checkbox-container">
          <div className="common-columns">
            <div className="common-column">
              {contexts.slice(0, 3).map((context) => (
                <div key={context.id} className="common-toggle-group">
                  <div className="common-toggle-info">
                    <h4>{context.label}</h4>
                  </div>
                  <div
                    className={`common-toggle ${
                      value.includes(context.id) ? "active" : ""
                    }`}
                    onClick={() => handleCheckboxChange(context.id)}
                  />
                </div>
              ))}
            </div>

            <div className="common-column">
              {contexts.slice(3, 6).map((context) => (
                <div key={context.id} className="common-toggle-group">
                  <div className="common-toggle-info">
                    <h4>
                      {context.icon} {context.label}
                    </h4>
                  </div>
                  <div
                    className={`common-toggle ${
                      value.includes(context.id) ? "active" : ""
                    }`}
                    onClick={() => handleCheckboxChange(context.id)}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CommunicationContext;
